import { DomMutationHeuristic } from '@cast/analytics';

import {
  isDialogElement,
  isDrawerElement,
  resolveDialogAttributes,
  resolveDrawerAttributes,
} from './_utils';

const tryParseDrawerEvent: DomMutationHeuristic = (node, status) => {
  if (!isDrawerElement(node)) {
    return;
  }
  const drawerAttributes = resolveDrawerAttributes(node);
  if (!drawerAttributes) {
    return;
  }
  return {
    title: `Drawer ${status}`,
    type: 'drawer',
    status,
    ...drawerAttributes,
  };
};

const tryParseDialogEvent: DomMutationHeuristic = (node, status) => {
  if (!isDialogElement(node)) {
    return;
  }
  const dialogAttributes = resolveDialogAttributes(node);
  if (!dialogAttributes) {
    return;
  }
  return {
    title: `Dialog ${status}`,
    type: 'dialog',
    status,
    ...dialogAttributes,
  };
};

export const domMutationHeuristics: DomMutationHeuristic[] = [
  tryParseDrawerEvent,
  tryParseDialogEvent,
];
